import $ from 'jquery';
import BasePropertyView from 'BasePropertyView';
import template from 'properties/main/password.ejs';
import listService from 'ListService';
import constants        from 'Constants';
import util from "util/Util";

class MainPasswordView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'click img' : 'alignmentHandler',
            'change #passwordRequiredChars' : 'updateSelectAttributes'
        };

        if (!this.model.get('align')) {
            this.model.set('align', 'left', constants.MODEL_SILENT);
        }

        let mobileDesignerStyle = listService.mainKind === constants.KIND_MOBILE ? "display: none;" : "";
        this.model.set('mobileDesignerStyle', mobileDesignerStyle, constants.MODEL_SILENT);

        // Realize the UI model "align" attribute as the UI alignment highlight model value
        this.clearAlignmentSelections();
        const alignmentHilight =
            { 'left': 'alignLeftSelection', 'center': 'alignCenterSelection', 'right': 'alignRightSelection'}[this.model.get('align')];
        this.model.set( alignmentHilight, this.selectedColor, constants.MODEL_SILENT);

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set( propName, propVal );
    }

    clearAlignmentSelections() {
        ['alignLeftSelection', 'alignCenterSelection', 'alignRightSelection']
            .forEach( v => this.model.set(v, this.unselectedColor, constants.MODEL_SILENT )) ;
    }

    switchAlignment( propName ) {
        let newValue;

        this.clearAlignmentSelections();

        if (propName === "align-center") {
            newValue = "center";
            this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);
        } else if (propName === "align-right") {
            newValue = "right";
            this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);
        }
        else if (propName === "align-left") {
            newValue = "left";
            this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
        }
        this.model.set('align', newValue);
    }

    alignmentHandler(ev) {
        ev.preventDefault();
        this.switchAlignment( ev.currentTarget.name );
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set( 'format', propVal );

        console.log(`NavigationView model.set(${propName}, ${this.model.get( propName )})`);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        //Set Dropdown
        if (this.model.get('format')) {
            var ddValue = this.model.get('format');
            var ddl = $('#passwordRequiredChars');
            ddl.val(ddValue);
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

}

export default MainPasswordView;
